/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";

import { connect } from "react-redux";

// Dashboard components
import MDBox from "components/MDBox";

import { useFormik } from "formik";
import TextError from "utils/TextError";
import * as Yup from "yup";

// Dashboard components
// import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";
// @mui material component

import DeleteIcon from "@mui/icons-material/Delete";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";

import Tooltip from "@mui/material/Tooltip";

// Functions from store
import {
  createComponents,
  deleteComponents,
  getComponents,
  getSubModulesByRoleId,
  updateUserComponents,
} from "../../../store";

// Cookies
import CloseIcon from "@mui/icons-material/Close";
import Cookies from "universal-cookie";

import { CircularProgress } from "@mui/material";
import CreateButton from "components/standardized-components/CreateButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import EditButton from "components/standardized-components/EditButton";
// import MDTypography from "components/MDTypography";

const cookies = new Cookies();
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 0,
  pt: 3,
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 340, sm: 340, md: 340, lg: 330, xl: 330 },
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const Components = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getComponents,
  componentsReducer,
  updateUserComponents,
  createComponents,
  deleteComponents,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;
  let userId = loginDetails.data.userId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  useEffect(() => {
    getComponents(jwtToken);
  }, []);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let componentsModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "5fc60000-a92b-4065-b676-2d535c3c2fbf",
  );

  let createAccess = componentsModule
    ? componentsModule.actionId.includes("989c8874-7788-4e2c-a4a6-386a261584a7")
    : null;
  let updateAccess = componentsModule
    ? componentsModule.actionId.includes("6caf5517-d478-42d9-85b1-7c5167e79fe5")
    : null;
  let editAccess = componentsModule
    ? componentsModule.actionId.includes("9f993197-9f37-4c41-b983-7658437bdbe7")
    : null;
  let deleteAccess = componentsModule
    ? componentsModule.actionId.includes("109f55ca-6a44-4207-9b20-2adca3575598")
    : null;

  const [state, setState] = useState({
    columns: [
      { Header: "Component Name", accessor: "componentName" },
      { Header: "Component Code", accessor: "componentCode" },
      { Header: "Component Description", accessor: "componentDescription" },
      { Header: "Modules", accessor: "moduleNames" },
      { Header: "action", accessor: "action" },
    ],
    rows: [],
  });
  const { columns, rows } = state;

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let tempComponents = [];

    let data = componentsReducer.components.data
      ? componentsReducer.components.data
      : [];
    setLoading(componentsReducer.loading);

    data.map((component) => {
      const compObj = {
        componentName: component.componentName,
        componentCode: component.componentCode,
        componentDescription: component.componentDescription,
        moduleNames: component.moduleNames,
        action: (
          <div>
            {editAccess && (
              <EditButton
                tooltip="Edit"
                // disabled={assets.isEditable === 0}
                variant="gradient"
                color="success"
                iconOnly
                type="button"
                onClick={() => handleOpenUpdateModal(component)}
                style={{ marginRight: "5px" }}
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            )}
            {deleteAccess && (
              <DeleteButton
                tooltip="Delete Role"
                // style={{ marginLeft: "10px" }}
                variant="gradient"
                color="error"
                iconOnly
                type="button"
                onClick={() => handleOpenDeleteComponentsModal(component)}
              >
                <DeleteIcon />
              </DeleteButton>
            )}
          </div>
        ),
      };
      tempComponents.push(compObj);
    });
    setState({ ...state, rows: tempComponents });
  }, [componentsReducer]);

  const [openDeleteRolesModal, setOpenDeleteRolesModal] = useState(false);
  const [singleComponentDataForDelete, setSingleComponentDataForDelete] =
    useState({});

  const handleOpenDeleteComponentsModal = (component = {}) => {
    setSingleComponentDataForDelete(component);
    setOpenDeleteRolesModal(true);
  };

  const handleClosedeleteComponentsModal = () => {
    setOpenDeleteRolesModal(false);
  };
  const [isErrordeleteRoles, setIsErrordeleteRoles] = useState(false);

  useEffect(() => {
    if (isErrordeleteRoles) {
      setTimeout(() => {
        setIsErrordeleteRoles(false);
      }, 3000);
    }
  }, [isErrordeleteRoles]);

  const [deleteErrorMsg, setDeleteErrorMsg] = useState("");

  const [isErrorForFgDelete, setIsErrorForFgDelete] = useState(false);
  const [isSuccessForDeleteForFg, setIsSuccessForDeleteForFg] = useState(false);

  useEffect(() => {
    if (isErrorForFgDelete) {
      setTimeout(() => {
        setIsErrorForFgDelete(false);
      }, 3000);
    }
  }, [isErrorForFgDelete]);
  useEffect(() => {
    if (isSuccessForDeleteForFg) {
      setTimeout(() => {
        setIsSuccessForDeleteForFg(false);
      }, 2000);
    }
  }, [isSuccessForDeleteForFg]);

  const deleteComponentsData = async () => {
    let componentId = singleComponentDataForDelete.componentId;
    let response = await deleteComponents(componentId, jwtToken);
    if (response.status) {
      setIsSuccessForDeleteForFg(true);
      getComponents(jwtToken);
      setTimeout(() => {
        handleClosedeleteComponentsModal();
      }, 2000);
    }
    if (!response.status) {
      setIsErrorForFgDelete(true);
      setDeleteErrorMsg(response.data.data.message);
      setIsErrordeleteRoles(true);
    }
  };

  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [singleComponentDataForUpdate, setComponentDataForUpdate] = useState(
    {},
  );
  const handleOpenUpdateModal = (Asset = {}) => {
    setComponentDataForUpdate(Asset);
    setOpenUpdateModal(true);
    setIsErrorForUpdate(false);
    setIsSuccessForUpdate(false);
  };
  const handleCloseUpdateAssetModal = () => {
    setOpenUpdateModal(false);
    formikForUpdate.setErrors({});
  };

  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const initialValueForUpdate = {
    componentName: singleComponentDataForUpdate.componentName,
    componentCode: singleComponentDataForUpdate.componentCode,
    componentDescription: singleComponentDataForUpdate.componentDescription,
  };

  const validationSchemaForUpdate = Yup.object({
    // assetName: Yup.string().required("Enter the asset name!"),
  });

  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");
  const [editButtonName, setEditButtonName] = useState("Submit");
  const onSubmitForUpdate = async (values) => {
    setEditButtonName("Please wait...");
    let payload = {
      componentId: singleComponentDataForUpdate.componentId,
      componentName: values.componentName,
      componentCode: values.componentCode,
      componentDescription: values.componentDescription,
      userId: userId,
    };
    let res = await updateUserComponents(payload, jwtToken);
    if (res.status) {
      setIsSuccessForUpdate(true);
      getComponents(jwtToken);
      setTimeout(() => {
        setEditButtonName("Submit");
      }, 2250);
    }
    if (!res.status) {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdate(res.data.data.msg);
      setEditButtonName("Submit");
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    // validationSchema: validationSchemaForUpdate,
    enableReinitialize: true,
  });

  const [openCreateAssetModal, setOpenCreateAssetModal] = useState(false);

  const handleOpenCreateAssetModal = () => {
    setOpenCreateAssetModal(true);
  };

  const handleCloseCreateAssetModal = () => {
    setOpenCreateAssetModal(false);
    // setAssetTypeSelected("");
    formikForCreateAsset.setValues(initialValueForCreateAsset);
    formikForCreateAsset.setTouched({});
    formikForCreateAsset.setErrors({});
  };

  const [isErrorCreateNewAsset, setIsErrorCreateNewAsset] = useState(false);
  const [isSuccessCreateNewAsset, setIsSuccessCreateNewAsset] = useState(false);

  useEffect(() => {
    if (isErrorCreateNewAsset) {
      setTimeout(() => {
        setIsErrorCreateNewAsset(false);
      }, 5000);
    }
  }, [isErrorCreateNewAsset]);

  useEffect(() => {
    if (isSuccessCreateNewAsset) {
      setTimeout(() => {
        setIsSuccessCreateNewAsset(false);
      }, 3000);
    }
  }, [isSuccessCreateNewAsset]);

  const initialValueForCreateAsset = {
    componentName: "",
    componentCode: "",
    componentDescription: "",
  };

  let isRequired = true;

  const validationSchema = Yup.object({
    componentName: Yup.string().required("Enter the component Name"),
    componentCode: Yup.string().required("Enter the component Code"),
    componentDescription: Yup.string().required(
      "Enter the component Description",
    ),
  });

  const [buttonName, setButtonName] = useState("Create");
  const [errorMsgForCreate, setErrorMsgForCreate] = useState("");
  const onSubmitForCreateAssetMaster = async (values, { resetForm }) => {
    setButtonName("Please wait...");
    let payload = {
      componentName: values.componentName,
      componentCode: values.componentCode,
      componentDescription: values.componentDescription,
      userId: userId,
    };
    let res = await createComponents(payload, jwtToken);
    if (res.status) {
      setIsSuccessCreateNewAsset(true);
      getComponents(jwtToken);
      setTimeout(() => {
        setButtonName("Create");
      }, 2250);

      resetForm();
    }
    if (!res.status) {
      setErrorMsgForCreate(res.data.data.message);
      setIsErrorCreateNewAsset(true);
      setButtonName("Create");
    }
  };

  const formikForCreateAsset = useFormik({
    initialValues: initialValueForCreateAsset,
    validationSchema: validationSchema,
    onSubmit: onSubmitForCreateAssetMaster,
  });

  return (
    <MDBox mt={-8}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Modal
            open={openDeleteRolesModal}
            onClose={handleClosedeleteComponentsModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <MDCard sx={deleteStyle}>
              <MDTypography>Are you sure you want to delete?</MDTypography>
              <MDBox mt={2}>
                <div style={{ display: "flex" }}>
                  <div>
                    <MDButton
                      style={{ width: "100%", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleClosedeleteComponentsModal}
                    >
                      Cancel
                    </MDButton>
                  </div>
                  <div>
                    <MDButton
                      style={{ width: "100%", marginLeft: "0.5rem" }}
                      color="error"
                      onClick={deleteComponentsData}
                    >
                      Delete
                    </MDButton>
                  </div>
                </div>
              </MDBox>
              <MDBox mt={2}>
                <Collapse in={isErrorForFgDelete}>
                  <Alert
                    severity="error"
                    action={
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => {
                          setIsErrorForFgDelete(false);
                        }}
                      >
                        <CloseIcon fontSize="inherit" />
                      </IconButton>
                    }
                  >
                    {/* Please check the details. Server error! */}
                    {deleteErrorMsg}
                  </Alert>
                </Collapse>
                <Collapse in={isSuccessForDeleteForFg}>
                  <Alert
                    severity="success"
                    action={
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => {
                          setIsSuccessForDeleteForFg(false);
                        }}
                      >
                        <CloseIcon fontSize="inherit" />
                      </IconButton>
                    }
                  >
                    Deleted Successfully
                  </Alert>
                </Collapse>
              </MDBox>
            </MDCard>
          </Modal>
          <Modal
            open={openUpdateModal}
            onClose={handleCloseUpdateAssetModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <MDCard sx={style}>
              <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                  Update
                </MDTypography>
                <MDBox>
                  <Tooltip title="Close">
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      onClick={handleCloseUpdateAssetModal}
                      style={{
                        background: "whitesmoke",
                        color: "black",
                        borderRadius: 5,
                        marginLeft: "-55px",
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </MDBox>
              </MDBox>
              <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

              <MDBox pt={1} pb={3} px={3}>
                <MDBox
                  component="form"
                  role="form"
                  onSubmit={formikForUpdate.handleSubmit}
                >
                  <MDBox mb={2}>
                    <MDTypography variant="h6">Component Name</MDTypography>
                    <MDInput
                      type="text"
                      name="componentName"
                      fullWidth
                      autoComplete="off"
                      onBlur={formikForUpdate.handleBlur}
                      onChange={formikForUpdate.handleChange}
                      value={formikForUpdate.values.componentName}
                      error={
                        formikForUpdate.touched.componentName &&
                        formikForUpdate.errors.componentName &&
                        true
                      }
                      inputProps={{
                        maxLength: 45,
                      }}
                    />
                    {formikForUpdate.touched.componentName &&
                      formikForUpdate.errors.componentName && (
                        <TextError msg={formikForUpdate.errors.componentName} />
                      )}
                  </MDBox>
                  <MDBox mb={2}>
                    <MDTypography variant="h6">Component Code</MDTypography>
                    <MDInput
                      type="text"
                      name="componentCode"
                      fullWidth
                      autoComplete="off"
                      onBlur={formikForUpdate.handleBlur}
                      onChange={formikForUpdate.handleChange}
                      value={formikForUpdate.values.componentCode}
                      error={
                        formikForUpdate.touched.componentCode &&
                        formikForUpdate.errors.componentCode &&
                        true
                      }
                      inputProps={{
                        maxLength: 45,
                      }}
                    />
                    {formikForUpdate.touched.componentCode &&
                      formikForUpdate.errors.componentCode && (
                        <TextError msg={formikForUpdate.errors.componentCode} />
                      )}
                  </MDBox>
                  <MDBox mb={2}>
                    <MDTypography variant="h6">
                      Component Description
                    </MDTypography>
                    <MDInput
                      multiline
                      rows={3}
                      type="text"
                      name="componentDescription"
                      fullWidth
                      autoComplete="off"
                      onBlur={formikForUpdate.handleBlur}
                      onChange={formikForUpdate.handleChange}
                      value={formikForUpdate.values.componentDescription}
                      error={
                        formikForUpdate.touched.componentDescription &&
                        formikForUpdate.errors.componentDescription &&
                        true
                      }
                      // inputProps={{
                      //   maxLength: 45,
                      // }}
                    />
                    {formikForUpdate.touched.componentDescription &&
                      formikForUpdate.errors.componentDescription && (
                        <TextError
                          msg={formikForUpdate.errors.componentDescription}
                        />
                      )}
                  </MDBox>

                  <MDBox>
                    <Collapse in={isErrorForUpdate}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorForUpdate(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {errorMsgForUpdate}
                      </Alert>
                    </Collapse>
                    <Collapse in={isSuccessForUpdate}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorForUpdate(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Updated successfully
                      </Alert>
                    </Collapse>
                  </MDBox>
                  <MDBox mt={3}>
                    <MDButton
                      variant="contained"
                      color="success"
                      fullWidth
                      type="submit"
                      disabled={
                        !formikForUpdate.isValid ||
                        editButtonName === "Please wait..."
                      }
                    >
                      {editButtonName}
                    </MDButton>
                  </MDBox>
                </MDBox>
              </MDBox>
            </MDCard>
          </Modal>

          <Modal
            open={openCreateAssetModal}
            onClose={handleCloseCreateAssetModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <MDCard sx={style}>
              <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                  Create
                </MDTypography>
                <Tooltip title="Close">
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    onClick={handleCloseCreateAssetModal}
                    style={{
                      background: "whitesmoke",
                      color: "black",
                      borderRadius: 5,
                      marginLeft: "-55px",
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </MDBox>
              <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

              <MDBox pt={1} pb={3} px={3}>
                <MDBox
                  component="form"
                  role="form"
                  onSubmit={formikForCreateAsset.handleSubmit}
                >
                  <MDBox>
                    <MDBox mb={2}>
                      <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                        Component Name
                      </MDTypography>

                      <MDInput
                        type="text"
                        name="componentName"
                        fullWidth
                        autoComplete="off"
                        onBlur={formikForCreateAsset.handleBlur}
                        onChange={formikForCreateAsset.handleChange}
                        value={formikForCreateAsset.values.componentName}
                        error={
                          formikForCreateAsset.touched.componentName &&
                          formikForCreateAsset.errors.componentName
                        }
                      />

                      {/* Display error message only if there is an error */}
                      {formikForCreateAsset.touched.componentName &&
                        formikForCreateAsset.errors.componentName && (
                          <TextError
                            msg={formikForCreateAsset.errors.componentName}
                          />
                        )}
                    </MDBox>
                    <MDBox mb={2}>
                      <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                        Component Code
                      </MDTypography>

                      <MDInput
                        type="text"
                        name="componentCode"
                        fullWidth
                        autoComplete="off"
                        onBlur={formikForCreateAsset.handleBlur}
                        onChange={formikForCreateAsset.handleChange}
                        value={formikForCreateAsset.values.componentCode}
                        error={
                          formikForCreateAsset.touched.componentCode &&
                          formikForCreateAsset.errors.componentCode
                        }
                      />

                      {/* Display error message only if there is an error */}
                      {formikForCreateAsset.touched.componentCode &&
                        formikForCreateAsset.errors.componentCode && (
                          <TextError
                            msg={formikForCreateAsset.errors.componentCode}
                          />
                        )}
                    </MDBox>
                    <MDBox mb={2}>
                      <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                        Component Description
                      </MDTypography>

                      <MDInput
                        type="text"
                        name="componentDescription"
                        fullWidth
                        autoComplete="off"
                        onBlur={formikForCreateAsset.handleBlur}
                        onChange={formikForCreateAsset.handleChange}
                        value={formikForCreateAsset.values.componentDescription}
                        error={
                          formikForCreateAsset.touched.componentDescription &&
                          formikForCreateAsset.errors.componentDescription
                        }
                      />

                      {/* Display error message only if there is an error */}
                      {formikForCreateAsset.touched.componentDescription &&
                        formikForCreateAsset.errors.componentDescription && (
                          <TextError
                            msg={
                              formikForCreateAsset.errors.componentDescription
                            }
                          />
                        )}
                    </MDBox>

                    <MDBox mt={2}>
                      <Collapse in={isSuccessCreateNewAsset}>
                        <Alert
                          severity="success"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsSuccessCreateNewAsset(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          Component Created successfully!
                        </Alert>
                      </Collapse>
                      <Collapse in={isErrorCreateNewAsset}>
                        <Alert
                          severity="error"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorCreateNewAsset(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {errorMsgForCreate}
                        </Alert>
                      </Collapse>
                    </MDBox>

                    <div className="mt-3">
                      <MDButton
                        type="submit"
                        variant="gradient"
                        color="info"
                        fullWidth
                        // disabled={
                        //   !formikForCreateAsset.isValid ||
                        //   (assetTypeSelected?.value === 5 &&
                        //     formikForCreateAsset.values.ip == "") ||
                        //   (assetTypeSelected?.value === 5 &&
                        //     formikForCreateAsset.values.port == "")||buttonName==="Please wait..."
                        // }
                      >
                        {buttonName}
                      </MDButton>
                    </div>
                  </MDBox>
                </MDBox>
              </MDBox>
            </MDCard>
          </Modal>

          {createAccess && (
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={3}
            >
              <MDBox>
                <CreateButton
                  tooltip="Create Role"
                  color="info"
                  variant="contained"
                  type="button"
                  onClick={() => {
                    handleOpenCreateAssetModal();
                  }}
                >
                  <Icon>add</Icon>
                </CreateButton>
              </MDBox>
            </MDBox>
          )}
          <MDBox mt={createAccess ? -3 : 0}>
            {!loading ? (
              <DataTable
                table={{ columns, rows }}
                isSorted={true}
                tableSearch={true}
                entriesPerPage={{
                  defaultValue: 5,
                  entries: [5, 10, 15, 20, 25, 30],
                }}
                showTotalEntries={true}
                noEndBorder
              />
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "100px",
                  marginBottom: "100px",
                }}
              >
                <CircularProgress color="info" />
              </div>
            )}
          </MDBox>
        </Grid>
      </Grid>
    </MDBox>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    componentsReducer: state.getComponentsReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getComponents: (jwtToken) => dispatch(getComponents(jwtToken)),
    createComponents: (payload, jwtToken) =>
      dispatch(createComponents(payload, jwtToken)),
    updateUserComponents: (payload, jwtToken) =>
      dispatch(updateUserComponents(payload, jwtToken)),
    deleteComponents: (componentId, jwtToken) =>
      dispatch(deleteComponents(componentId, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(Components);
